import Header from '../components/Header';
import Hero from '../components/Hero';
import FlowFieldBackground from '../components/landing/FlowFieldBackground';
import SignalFoundationBridge from '../components/landing/SignalFoundationBridge';
import IntegrationsStrip from '../components/landing/IntegrationsStrip';
import StoriesFaqBridge from '../components/landing/StoriesFaqBridge';
import CtaFooterBridge from '../components/landing/CtaFooterBridge';
import PageEdgeLines from '../components/marketing/PageEdgeLines';

export default function LandingPage() {
  return (
    <div className="landing-page min-h-screen flex flex-col bg-grain" style={{ background: 'var(--bg-base)' }}>
      <PageEdgeLines side="left" />
      <PageEdgeLines side="right" />
      <Header />
      <main className="flex-1">
        <div style={{ position: 'relative', overflow: 'hidden', background: 'var(--bg-base)' }}>
          <FlowFieldBackground gradientId="hero-integrations-flow-grad" uniformStroke />
          <div style={{ position: 'relative', zIndex: 1 }}>
            <Hero showFlowBackground={false} />
            <IntegrationsStrip showTopBorder={false} flowThrough />
          </div>
        </div>
        <SignalFoundationBridge />
        <StoriesFaqBridge />
        <CtaFooterBridge />
      </main>
    </div>
  );
}
